module.exports = __webpack_public_path__ + "img/icon4.f7684850.png";